import { render, staticRenderFns } from "./componentRender.vue?vue&type=template&id=56fdd12e"
import script from "./componentRender.vue?vue&type=script&lang=js"
export * from "./componentRender.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports